//import logo from './logo.svg';
import "./App.css";

import xlsx from "xlsx";

import { ChakraProvider,Box,Center } from "@chakra-ui/react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

import WindowCourseCalendar from "./pages/objCPCal";
import CourseCalendar from "./pages/objCP";
import SheetJSApp from "./pages/misc/objXL";

import PdView from "./pages/subPages/objPd";



function App() {
  return (
    <ChakraProvider>
      <Box w="100%" minH="100vh" bg="green.400">
        <Center>
          <Router>
            
            <Switch>
              <Route path="/pd/">
                <PdView />
              </Route>
            <Route path="/testing/">
                test
              </Route>
              <Route path="/excel/">
                Execel
                <SheetJSApp />
              </Route>

              <Route path="/w-course-calendar/">
                <WindowCourseCalendar />
              </Route>

              <Route path="/work/">
                <CourseCalendar />
              </Route>

              <Route exact path="/">
                home
              </Route>
            </Switch>
          
        </Router>
        </Center>
      </Box>
      
    </ChakraProvider>
  );
}

export default App;
